import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=5af58829&scoped=true&"
import script from "./goodList.vue?vue&type=script&lang=js&"
export * from "./goodList.vue?vue&type=script&lang=js&"
import style0 from "./goodList.vue?vue&type=style&index=0&id=5af58829&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af58829",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af58829')) {
      api.createRecord('5af58829', component.options)
    } else {
      api.reload('5af58829', component.options)
    }
    module.hot.accept("./goodList.vue?vue&type=template&id=5af58829&scoped=true&", function () {
      api.rerender('5af58829', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/importGoods/goodList.vue"
export default component.exports